
const drawerStyles = theme => ({
    drawer: {
        display: "flex",
        height: "100%"
    },
    drawerWrapper: {
        display: "flex",
        width: 345,
        maxWidth: 345,
        height: "100%",
        borderRight: "1px solid #EDEDED",
        overflow: "hidden",
        transition: "all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    },
    closedDrawer: {
        width: "0px !important",
        maxWidth: "0px !important"
    },
    drawercontainer: {
        display: "flex",
        width: 345,
        minWidth:345,
        height: "100%",
        flexDirection:"column"
    },
    openDrawerIcon: {
        position:"absolute",
        cursor: "pointer",
        left: 0,
        height: 75,
        width: 43,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRight: "1px solid grey",
        borderBottom: "1px solid grey",
        transition: "all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
        background:"white",
        zIndex:1
    },
    openImage: {
        transform: "rotate(90deg)",
        height: 24,
        width: 24,
    },
    hideDrawerIcon: {
        display: "none",
    },
    drawerHeader: {
        display: "flex",
        height: 75,
        justifyContent: "center",
        alignItems: "center",
        borderBottom: "1px solid rgba(109,114,120,0.15)"
    },
    drawerHeaderTitle: {
        color: "#000000",
        fontFamily: "Proxima Nova",
        fontSize: 24,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "41px"
    },
    closeDrawerIcon: {
        transform: "rotate(-90deg)",
        height: 24,
        width: 24,
        marginLeft: 28,
        cursor:"pointer"
    },
    cardContainer:{
        display:"flex",
        flex:1,
        overflow:"auto",
        flexDirection:"column",
        paddingTop:42,
        paddingBottom:27
    },
    cardWrapper:{
        marginBottom:15
    }
})

export default drawerStyles;